export default __webpack_public_path__ + "static/media/icons8-business-building.0bfaae3b.svg";